import { __assign, __rest } from "tslib";
import React, { useContext, useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { getIndentClassName } from '../../styles';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiDataHook, BiEventType } from '@wix/da-bi/pkg/constants';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import Comment from '../../../Comment/presets/Comment';
import Flex from '@wix/da-ds/pkg/Flex';
import ViewReplies from '../ViewReplies';
import s from './RecursiveComment.scss';
var RecursiveComment = function (_a) {
    var comment = _a.comment, index = _a.index, props = __rest(_a, ["comment", "index"]);
    var maxDepth = props.maxDepth, commentableItemId = props.commentableItemId, commentableTypeId = props.commentableTypeId, canPostComment = props.canPostComment, isReplyingToParent = props.isReplyingToParent, _b = props.commentComponent, CommentComponent = _b === void 0 ? Comment : _b, commentClassName = props.commentClassName, commentWrapperClassName = props.commentWrapperClassName, viewRepliesClassName = props.viewRepliesClassName, setCommentRef = props.setCommentRef, onCommentMouseOver = props.onCommentMouseOver, setVerticalIndicatorRef = props.setVerticalIndicatorRef, onEditingStateChange = props.onEditingStateChange, onOpenCommentModal = props.onOpenCommentModal, onThreadUpdated = props.onThreadUpdated;
    var commentId = comment.commentId, indent = comment.indent, isLeafComment = comment.isLeafComment, children = comment.children, parentId = comment.parentId, replies = comment.replies;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var logBiEvent = useBiLogger();
    var openReplies = useCallback(function () {
        logBiEvent({
            evid: BiEventType.CLICK_VIEW_REPLY_TO_COMMENT,
            itemid: commentableItemId,
            typeid: commentableTypeId,
            commentid: commentId,
            commenterid: comment.user.useridUuid,
        });
        // If we already in iframe just redirect
        if (window.self !== window.top) {
            window.location.assign(Url.commentLink(commentableTypeId, commentableItemId, commentId, undefined, true));
            return;
        }
        onOpenCommentModal(commentableTypeId, commentableItemId, commentId, comment);
    }, [
        commentableItemId,
        commentableTypeId,
        logBiEvent,
        onOpenCommentModal,
        comment,
        commentId,
    ]);
    var hasMoreReplies = isLeafComment && replies > 0 && indent >= maxDepth;
    var indentClassName = getIndentClassName(indent, isMobile);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classnames(indentClassName, s['comment-wrapper'], parentId &&
                !isReplyingToParent &&
                index > 0 &&
                s['comment-wrapper-child'], hasMoreReplies && s['has-more-replies'], commentWrapperClassName), ref: function (element) { return setCommentRef(commentId, element); }, "data-hook": BiDataHook.COMMENTS_THREAD_ITEM, onMouseOver: function () {
                return onCommentMouseOver(commentId, parentId, isReplyingToParent);
            } },
            parentId && index > 0 && (React.createElement("div", { className: s['vertical-indicator'], ref: function (element) { return setVerticalIndicatorRef(commentId, element); } })),
            React.createElement(CommentComponent, { key: "comment-".concat(commentId), comment: comment, className: classnames(s['comment'], commentClassName), onReplyPosted: onThreadUpdated, onCommentUpdated: onThreadUpdated, canPostComment: !!canPostComment, onEditingStateChange: function (state) { return onEditingStateChange(commentId, state); } })),
        children &&
            children.map(function (child) { return (React.createElement(RecursiveComment, __assign({ key: "comment-wrap-".concat(child.commentId), comment: child, index: child.index }, props))); }),
        hasMoreReplies && (React.createElement(Flex, { className: classnames(s['view-replies-wrapper'], viewRepliesClassName, isMobile && indentClassName), justifyContent: "flex-end" },
            React.createElement(ViewReplies, { onClick: openReplies }, t('commentthread.control.viewReplies'))))));
};
RecursiveComment.displayName = 'RecursiveComment';
export default RecursiveComment;
//# sourceMappingURL=RecursiveComment.js.map